import { Link } from "react-router-dom";
import { OwlMark } from "./Logo";
import { useContent } from "@/lib/api";

export const Footer = () => {
  const { data } = useContent();
  const s = data?.settings || {};
  return (
    <footer className="bg-ink text-stone-300" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 pb-10 pt-16 sm:px-8 sm:pt-24 lg:px-16">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-6">
            <div className="flex items-center gap-3">
              <OwlMark className="h-10 w-10" body="#FAF8F5" face="#1C1917" />
              <span className="font-serif text-2xl text-bone">The Owl&rsquo;s Nest</span>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-stone-400">
              An intimate event venue with charcuterie offerings in Joshua, Texas, hosting gatherings
              of up to {s.capacity || 100} guests. Availability is subject to confirmation — an inquiry
              does not hold a date.
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="overline-label !text-stone-500">Explore</p>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link className="hover:text-bone" to="/space">The Space</Link></li>
              <li><Link className="hover:text-bone" to="/availability">Availability</Link></li>
              <li><Link className="hover:text-bone" to="/inquire">Event Inquiry</Link></li>
              <li><Link className="hover:text-bone" to="/faq">FAQs & Contact</Link></li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="overline-label !text-stone-500">Contact</p>
            <ul className="mt-4 space-y-2.5 text-sm text-stone-400">
              <li>{s.address}</li>
              <li><a className="hover:text-bone" href={`tel:${(s.contact_phone || "").replace(/[^+\d]/g, "")}`}>{s.contact_phone}</a></li>
              <li><a className="hover:text-bone" href={`mailto:${s.contact_email}`}>{s.contact_email}</a></li>
            </ul>
          </div>
        </div>
        <div className="mt-16 select-none overflow-hidden" aria-hidden="true">
          <p className="whitespace-nowrap text-center font-serif text-[13.5vw] leading-[0.85] tracking-tight text-bone/[0.07]">
            The Owl&rsquo;s Nest
          </p>
        </div>
        <div className="mt-8 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 text-xs text-stone-500 sm:flex-row">
          <p>&copy; {new Date().getFullYear()} The Owl&rsquo;s Nest. All rights reserved.</p>
          <Link to="/admin/login" className="transition-colors hover:text-bone" data-testid="footer-admin-link">
            Owner login
          </Link>
        </div>
      </div>
    </footer>
  );
};
